/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Top_RightInputs */

const en_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Right`)
};

const fr_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut Droite`)
};

const de_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben rechts`)
};

const it_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In alto a destra`)
};

const ru_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вверху справа`)
};

const es_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba a la derecha`)
};

const zh_cn2_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上角`)
};

const ja_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右上`)
};

const hi_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक तरह से ऊपर`)
};

const pt_pt2_input_position_top_right = /** @type {(inputs: Input_Position_Top_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto superior direito`)
};

/**
* | output |
* | --- |
* | "Top Right" |
*
* @param {Input_Position_Top_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_top_right = /** @type {((inputs?: Input_Position_Top_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Top_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_top_right(inputs)
	if (locale === "de") return de_input_position_top_right(inputs)
	if (locale === "it") return it_input_position_top_right(inputs)
	if (locale === "ru") return ru_input_position_top_right(inputs)
	if (locale === "es") return es_input_position_top_right(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_top_right(inputs)
	if (locale === "ja") return ja_input_position_top_right(inputs)
	if (locale === "hi") return hi_input_position_top_right(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_top_right(inputs)
	return en_input_position_top_right(inputs)
});